import React, { forwardRef } from 'react'
import axios from 'axios'
import Grid from '@blocks/Grid'

function Form<R = any>({ children, action = "", handleSubmit, handleSuccess, method = "post", ...attributes }: Props<R>, ref: React.Ref<HTMLFormElement>): JSX.Element {
    const onSubmit = async (e: any) => {
        e.preventDefault()

        const form = e.target
        const data = new FormData(form)

        const request = handleSubmit || async function (data: FormData) {
            const result = await axios({
                data: data,
                url: form.action,
                method: form.method
            }) 

            return result.data
        }

        const response = await request(data)

        handleSuccess(response, form)
    }

    return (
        <form className="form" action={action} method={method === "get" ? "get" : "post"} onSubmit={onSubmit} ref={ref} {...attributes}>
            <input type="hidden" name="_method" value={method} />
            <Grid gap="20px">{children}</Grid>
        </form>
    )
}

export default forwardRef<HTMLFormElement, Props>(Form) as typeof Form

interface Props<R extends any = any>  {
    children: React.ReactNode
    action?: string
    handleSubmit?(data: FormData): Promise<R>
    handleSuccess(data: R, form?: HTMLFormElement): void
    method?: "post" | "get" | "patch" | "delete"
}